import api from '@/api/index.js'

const money_claim = {
  state: {
    loading: false,
    money_claims: [],
    error: null,
  },

  mutations: {
    SET_MONEY_CLAIMS_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_MONEY_CLAIMS: (state, moneyClaims) => {
      state.money_claims = moneyClaims
      state.loading = false;
    },
    SET_MONEY_CLAIMS_ERROR: (state, error) => {
      state.error = error
    },
  },

  actions: {
    LoadMoneyClaims ({ commit }) {
      commit('SET_MONEY_CLAIMS_LOADING', true)
      commit('SET_MONEY_CLAIMS_ERROR', null)
      return api.get('money-claims?limit=0&offset=0')
        .then((response) => {
          commit('SET_MONEY_CLAIMS', response)
        })
        .catch((error) => commit('SET_ERROR', error))
        .catch((error) => {
          commit('SET_MONEY_CLAIMS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_MONEY_CLAIMS_LOADING', false)
        })
    }
  },
}

export default money_claim
